import { toast } from "react-toastify";
import {
  BANNER_ADD_SUCCESS,
  BANNER_ADD_REQUEST,
  BANNER_ADD_FAIL,
  //
  BANNER_LIST_SUCCESS,
  BANNER_LIST_REQUEST,
  BANNER_LIST_FAIL,
  //
  BANNER_DETAIL_SUCCESS,
  BANNER_DETAIL_REQUEST,
  BANNER_DETAIL_FAIL,
  //
  BANNER_DELETE_SUCCESS,
  BANNER_DELETE_REQUEST,
  BANNER_DELETE_FAIL,
  //
  BANNER_UPDATE_SUCCESS,
  BANNER_UPDATE_REQUEST,
  BANNER_UPDATE_FAIL,
  //

  //
} from "../constants/bannerConstants";

export const deleteBannerReducer = (state = {}, action) => {
  switch (action.type) {
    case BANNER_DELETE_REQUEST:
      return { loadingBannerDelete: true };
    case BANNER_DELETE_SUCCESS:
      toast.success("This Banner has been successfully deleted.");
      return {
        loadingBannerDelete: false,
        successBannerDelete: true,
      };
    case BANNER_DELETE_FAIL:
      return {
        loadingBannerDelete: false,
        errorBannerDelete: action.payload,
        successBannerDelete: false,
      };
    default:
      return state;
  }
};

export const updateCategoryReducer = (state = {}, action) => {
  switch (action.type) {
    case BANNER_UPDATE_REQUEST:
      return { loadingCategoryUpdate: true };
    case BANNER_UPDATE_SUCCESS:
      toast.success("This Category has been successfully updated");
      return {
        loadingCategoryUpdate: false,
        successCategoryUpdate: true,
      };
    case BANNER_UPDATE_FAIL:
      return {
        loadingCategoryUpdate: false,
        errorCategoryUpdate: action.payload,
        successCategoryUpdate: false,
      };
    default:
      return state;
  }
};

export const detailCategoryReducer = (state = { categoryInfo: {} }, action) => {
  switch (action.type) {
    case BANNER_DETAIL_REQUEST:
      return { loadingCategoryInfo: true };
    case BANNER_DETAIL_SUCCESS:
      return {
        loadingCategoryInfo: false,
        successCategoryInfo: true,
        categoryInfo: action.payload.category,
      };
    case BANNER_DETAIL_FAIL:
      return {
        loadingCategoryInfo: false,
        successCategoryInfo: false,
        errorCategoryInfo: action.payload,
      };
    default:
      return state;
  }
};

export const createNewBannerReducer = (state = {}, action) => {
  switch (action.type) {
    case BANNER_ADD_REQUEST:
      return { loadingBannerAdd: true };
    case BANNER_ADD_SUCCESS:
      toast.success("This Banner has been added successfully");
      return {
        loadingBannerAdd: false,
        successBannerAdd: true,
      };
    case BANNER_ADD_FAIL:
      toast.error(action.payload);
      return {
        loadingBannerAdd: false,
        successBannerAdd: false,
        errorBannerAdd: action.payload,
      };
    default:
      return state;
  }
};

export const getListBannersReducer = (state = { banners: [] }, action) => {
  switch (action.type) {
    case BANNER_LIST_REQUEST:
      return { loadingListBanners: true, banners: [] };
    case BANNER_LIST_SUCCESS:
      return {
        loadingListBanners: false,
        banners: action.payload.banners,
      };
    case BANNER_LIST_FAIL:
      return {
        loadingListBanners: false,
        errorListBanners: action.payload,
      };
    default:
      return state;
  }
};
